
// ABOUTME: Layout component that wraps all pages with sidebar and navigation
// ABOUTME: Provides consistent layout structure across all routes

import React, { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useIsMobile } from '@/hooks/use-mobile';
import AuthGuard from '@/components/AuthGuard';
import AppSidebar from '@/components/AppSidebar';
import Navigation from '@/components/Navigation';
import { SidebarProvider } from '@/components/ui/sidebar';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { user, profile, signOut } = useAuth();
  const isMobile = useIsMobile();

  return (
    <AuthGuard>
      <SidebarProvider>
        <div className="min-h-screen w-full bg-gray-50">
          {/* Mobile Navigation */}
          {isMobile && <Navigation />}
          
          <div className="flex w-full">
            <AppSidebar 
              user={user}
              profile={profile}
              onSignOut={signOut}
            />
            
            <main className="flex-1 min-w-0 overflow-x-hidden">
              <div className="w-full max-w-full">
                {children}
              </div>
            </main>
          </div>
        </div>
      </SidebarProvider>
    </AuthGuard>
  );
};

export default Layout;
